import { Component, OnInit, Inject } from '@angular/core';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { AtividadeService } from 'src/app/services/atividade.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import swal from 'sweetalert2';
import { Atividade } from 'src/app/models/atividade';
import { GlobalService } from 'src/app/services/global.service';
import { StatusDaAtividade } from 'src/app/models/enum';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UsuarioLogado } from 'src/app/models/usuario-logado';

@Component({
  selector: 'app-cadastro-atividade-modal',
  templateUrl: './cadastro-atividade-modal.component.html',
  styleUrls: ['./cadastro-atividade-modal.component.scss']
})
export class CadastroAtividadeModalComponent implements OnInit {
  idAtividade: number;
  idCliente: number;
  atividade: Atividade;

  usuarioLogado: UsuarioLogado;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private atividadeService: AtividadeService,
    private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CadastroAtividadeModalComponent>,
  ) {
  }

  async ngOnInit() {

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.idCliente = this.data.idCliente;

    if(this.data.idAtividade) {
      this.idAtividade = this.data.idAtividade;
      this.buscarAtividade();
    } else {
      this.atividade = new Atividade();
      this.atividade.status = StatusDaAtividade.Pendente;
      this.atividade.usuarioPendente = this.usuarioLogado.id;
      this.atividade.idCliente = this.idCliente;
    }
  }

  buscarAtividade() {
    this.carregandoService.mostra('buscaAtividade');

    this.atividadeService.consultarPorId(this.idAtividade).subscribe(ativ => {
      this.atividade = ativ;

      this.carregandoService.esconde('buscaAtividade');
    }, (erro) => {
      this.carregandoService.esconde('buscaAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  concluirAtividade() {
    this.atividade.status = StatusDaAtividade.Concluida;
    this.atividade.usuarioConcluiu = this.usuarioLogado.id;
    this.salvarAtividade();
  }

  cancelarAtividade() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente cancelar a atividade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('cancelarAtividade');

        this.atividade.usuarioConcluiu = this.usuarioLogado.id;
        this.atividade.status = StatusDaAtividade.Cancelada;

        this.atividadeService.salvar(this.atividade).subscribe(() => {
          this.notificacaoService.sucesso('Atividade cancelada com sucesso!!!');

          this.fechar();

          this.carregandoService.esconde('cancelarAtividade');
        }, (erro) => {
          this.carregandoService.esconde('cancelarAtividade');
          this.notificacaoService.erro(erro);
        });
      }
    });

  }

  salvarAtividade() {
    this.carregandoService.mostra('salvarAtividade');

    this.atividadeService.salvar(this.atividade).subscribe(ativ => {
      this.notificacaoService.sucesso('Atividade salva com sucesso!!!');

      this.fechar();

      this.carregandoService.esconde('salvarAtividade');
    }, (erro) => {
      this.carregandoService.esconde('salvarAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
